/* TODO: t() */
import React from 'react';
import { View, StyleSheet } from 'react-native';

import { themeColors } from './Constants';

type Props = {
  opacity?: number;
  style?: StyleSet;
  direction: 'horizontal' | 'vertical';
};

let styles = StyleSheet.create({
  root: {
    flex: 1,
    backgroundColor: themeColors.grey,
  },
  // eslint-disable-next-line react-native/no-unused-styles
  horizontal: {
    height: StyleSheet.hairlineWidth,
    minHeight: StyleSheet.hairlineWidth,
    maxHeight: StyleSheet.hairlineWidth,
  },
  // eslint-disable-next-line react-native/no-unused-styles
  vertical: {
    width: StyleSheet.hairlineWidth,
    minWidth: StyleSheet.hairlineWidth,
    maxWidth: StyleSheet.hairlineWidth,
  },
});

function Separator({ direction, opacity, style }: Props) {
  return (
    <View
      style={[
        styles.root,
        styles[direction],
        opacity ? { opacity } : undefined,
        style,
      ]}
    />
  );
}

Separator.defaultProps = {
  direction: 'horizontal',
};

Separator.size = StyleSheet.hairlineWidth;

export default Separator;
